import React from "react";

import {
    faTimes,
    faUpload,
    faChartLine,
    faSearch,
    faUsers,
    faMapMarkedAlt,
    faToolbox,
    faTruck,
    faFolder,
    faCamera,
    faFileSignature,
    faHeadset,
    faMapMarkerAlt,
    faShippingFast,
    faClock,
    faTruckLoading,
    faFileAlt,
    faUserNinja,
    faBuilding,
    faEdit,
    faHandshake,
    faBezierCurve,
    faArchive,
    faTruckFront,
    faAtom,
    faInfoCircle,
    faMinusCircle,
    faFolderMinus,
    faFileCirclePlus,
    faFileContract,
    faFileInvoiceDollar,
    faFileInvoice,
    faCog,
    faClipboardList,
    faExclamationTriangle,
    faRoute,
    faDownload,
    faBoxesStacked,
    faChartSimple,
    faTableList,
    faPencil,
    faMapLocationDot,
    faTextSlash,
    faReceipt,
    faServer,
    faCheck,
    faMoneyBill,
    faCashRegister,
    faScrewdriverWrench,
    faGasPump,
    faCircleNotch,
    faMessage,
    faWallet,
    faBoxesPacking,
    faCalendar,
    faTags
} from "@fortawesome/free-solid-svg-icons";

import LoadingComponent from "util/LoadingComponent";

export const LOADING = <LoadingComponent />;

export const PERMISSION = "ler";

export const MODULE_TESTER = [
    'romaneio', 'protocolo', 'pesquisa'
]

export const USER_TESTER = [
    'EMBARCADOR', 'DESTINATARIO', 'ENTREGADOR'
]

export const SECTIONS = {
    search: {
        nome: "",
        index: 0,
    },
    logistica: {
        nome: "Logística",
        index: 1,
    },
    transporte: {
        nome: "Transporte",
        index: 2,
    },
    financeiro: {
        nome: "Financeiro",
        index: 3,
    },
    fiscal: {
        nome: "Fiscal",
        index: 4,
    },
    atendimento: {
        nome: "Atendimento",
        index: 5,
    },
    gestao: {
        nome: "Gestão",
        index: 6,
    },
    ferramentas: {
        nome: "Ferramentas",
        index: 7,
    },
    integracoes: {
        nome: "Integrações",
        index: 8,
    }
}

export const DEFAULT_ROUTE = {
    route: "/dashboard/operacional",
};

export const DEFAULT_MODULE = {
    enabled: true,
    menu: true,
    id: "dashboard",
    route: "/dashboard",
    icon: faChartLine,
    title: "Dashboard",
    import: "Dashboard",
    children: [
        {
            enabled: true,
            menu: true,
            id: "analitico",
            // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
            route: "/analitico",
            icon: faFileAlt,
            title: "Analitico",
            import: "Analitico",
        },
        {
            enabled: true,
            menu: true,
            id: "operacional",
            // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
            route: "/operacional",
            icon: faFileAlt,
            title: "Operacional",
            import: "Operacional",
        },
    ],
};

export const IF_NEW_USER = {
    enabled: false,
    menu: false,
    id: "perfil",
    permission: false,
    route: "/perfil",
    icon: faTimes,
    title: "Perfil",

    import: "Perfil",
};

export const USER_DISABLED = [
    {
        enabled: true,
        menu: true,
        id: "pesquisa",
        route: "/pesquisa",
        icon: faSearch,
        title: "Pesquisa",
        import: "Pesquisar",
    },
    {
        enabled: true,
        menu: true,
        id: "azp",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/documentos/azp",
        icon: faFileAlt,
        title: "Azp",
        import: "CriarAzp",
    },
    {
        enabled: true,
        menu: true,
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        id: "devolucao",
        route: "/documentos/devolucoes",
        icon: faTruckLoading,
        title: "Devoluções",
        import: "Devolucoes",
    },
];

const LOGISTICA_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "romaneio",
        section: "logistica",
        route: "/romaneios",
        icon: faTruck,
        title: "Romaneios",
        import: "Romaneios",
    },
    {
        enabled: true,
        menu: true,
        id: "protocolo",
        section: "logistica",
        route: "/protocolos",
        icon: faFolder,
        title: "Protocolos",
        import: "Protocolos",
    },
    {
        enabled: true,
        menu: true,
        id: "documentos",
        route: "/documentos",
        section: "logistica",
        icon: faArchive,
        title: "Documentos",
        import: "Documentos",
        children: [
            {
                enabled: true,
                menu: true,
                id: "azp",
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/azp",
                icon: faFileAlt,
                title: "Azp",
                import: "CriarAzp",
            },
            {
                enabled: true,
                menu: true,
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "devolucao",
                route: "/devolucoes",
                icon: faTruckLoading,
                title: "Devoluções",
                import: "Devolucoes",
            },
        ],
    },
    {
        enabled: true,
        menu: true,
        id: "app_volumetria",
        route: "/volumetria",
        section: "logistica",
        icon: faBoxesStacked,
        title: "Volumetria",
        import: "V4",
        children: [
            {
                enabled: true,
                menu: true,
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "app_volumetria",
                route: "/sessoes",
                icon: faBoxesPacking,
                title: "Sessões",
                import: "V4",
            },
            {
                enabled: true,
                menu: true,
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "app_volumetria",
                route: "/volumes",
                icon: faBoxesStacked,
                title: "Volumes",
                import: "V4",
            },
            {
                enabled: true,
                menu: true,
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "app_volumetria",
                route: "/configuracao",
                icon: faCog,
                title: "Configurações",
                import: "V4",
            },
        ],
    },
]

const TRANSPORTE_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "romaneio_automatico",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/romaneio-automatico",
        section: 'transporte',
        icon: faMapMarkedAlt,
        title: "Romaneio automatico",
        import: "Ferramentas/RomaneioAutomatico",
    },
    {
        enabled: true,
        menu: true,
        id: "rastreamento",
        section: "transporte",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/rastreamento",
        icon: faMapMarkerAlt,
        title: "Rastreamento",
        import: "Rastreamento",
    },
    {
        enabled: true,
        menu: true,
        id: "roteirizacao",
        route: "/roteirizacao",
        section: "transporte",
        // permission: false,
        icon: faMapLocationDot,
        title: "Roteirização",
        import: "Roteirizacao",
        children: [
            {
                enabled: true,
                menu: true,
                id: "roteirizacao",
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/acompanhar",
                icon: faTableList,
                title: "Acompanhar",
                import: "Acompanhamento",
            },
            {
                enabled: true,
                menu: true,
                id: "roteirizacao",
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/gerar",
                icon: faPencil,
                title: "Gerar",
                import: "Gerar",
            },
            {
                enabled: true,
                menu: true,
                id: "roteirizacao",
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/processos",
                icon: faRoute,
                title: "Processos",
                import: "Processos",
            }
        ],
    },
    // {
    //     enabled: true,
    //     menu: true,
    //     id: "roteirizacao",
    //     section:"transporte",
    //     //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
    //     route: "/roteirizacao",
    //     icon: faRoute,
    //     title: "[BETA] Roteirização",
    //     import: "Roteirizacao",
    // },
    {
        enabled: true,
        menu: true,
        id: "rota",
        section: "transporte",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/rotas",
        icon: faMapMarkedAlt,
        title: "Rotas de entrega",
        import: "Ferramentas/Rota",
    },
]

const FINANCEIRO_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "frete",
        section: "financeiro",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/frete",
        icon: faFileInvoiceDollar,
        title: "Frete",
        import: "NEW_FRETE",
        children: [
            {
                enabled: true,
                menu: true,
                id: "frete",
                route: "/faturas",
                icon: faSearch,
                // permission:false,
                title: "Faturas",
                import: "Faturas",
            },
            {
                enabled: true,
                menu: true,
                id: "frete",
                route: "/cotacao",
                icon: faFileInvoice,
                // permission:false,
                title: "Cotação",
                import: "Cotacao",
            },
            {
                enabled: true,
                menu: true,
                super: true,
                id: "frete",
                route: "/contratos",
                icon: faFileCirclePlus,
                title: "Contratos",
                import: "V4",
            },
            {
                enabled: true,
                menu: true,
                super: true,
                id: "frete",
                route: "/taxas",
                icon: faTags,
                title: "Taxas",
                import: "V4",
            },
        ]
    },
    {
        enabled: true,
        menu: true,
        id: "tms",
        permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/financeiro",
        section: 'financeiro',
        icon: faCashRegister,
        title: "Financeiro",
        import: "V4",
        children: [
            {
                enabled: true,
                menu: true,
                id: "tms",
                route: "/titulos",
                icon: faCashRegister,
                // permission: false,
                title: "Títulos",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "tms",
                route: "/solicitacoes",
                icon: faReceipt,
                // permission: false,
                title: "Solicitações",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "tms",
                route: "/conta",
                icon: faWallet,
                // permission: false,
                title: "Contas bancárias",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "tms",
                route: "/configuracao",
                icon: faCog,
                // permission: false,
                title: "Configurações",
                import: "",
            },
        ]
    },
    {
        enabled: true,
        menu: true,
        id: "frotas",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "",
        section: 'financeiro',
        icon: faTruckFront,
        title: "Frotas",
        import: "V4",
        children: [
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas/dashboard",
                icon: faChartSimple,
                // permission: false,
                title: "Dashboard",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas",
                icon: faTruckFront,
                // permission: false,
                title: "Frotas",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas/manutencao",
                icon: faScrewdriverWrench,
                // permission: false,
                title: "Manutenção",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas/combustivel",
                icon: faGasPump,
                // permission: false,
                title: "Combustível",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas/pneus",
                icon: faCircleNotch,
                // permission: false,
                title: "Pneus",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "frotas",
                route: "/frotas/pendencias",
                icon: faExclamationTriangle,
                // permission: false,
                title: "Pendências",
                import: "",
            },
        ]
    },
    {
        enabled: true,
        menu: false,
        id: "torreControle",
        permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/torre_de_controle",
        section: 'financeiro',
        icon: faTextSlash,
        title: "Torre de Controle",
        import: "TorreControle",
    },
    {
        enabled: true,
        menu: true,
        id: "comprovacoes",
        section: "financeiro",
        route: "/comprovacoes",
        icon: faTimes,
        title: "Comprovações",
        import: "Comprovacoes",
    },

    {
        enabled: true,
        menu: true,
        id: "armazenamentoVisualizar",
        section: "financeiro",
        route: "/armazenamento",
        permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        icon: faReceipt,
        title: "Armazenamento",
        import: "Armazenamento",
    },
]

const FISCAL_SECTION_MODULES = [
    {
        //HeaderBadge alterado estáticamente, mudar routes caso mude rota
        enabled: true,
        menu: true,
        id: "cte",
        section: "fiscal",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/cte",
        icon: faFileSignature,
        title: "CTEs",
        import: "NEW_CTE",
        children: [
            {
                enabled: true,
                menu: true,
                id: "cte",
                route: "/listar",
                icon: faSearch,
                // permission:false,
                title: "Listar",
                import: "Listar",
            },
            {
                enabled: true,
                menu: false,
                visible: false,
                id: "cte",
                route: "/editar",
                // permission:false,
                title: "Editar",
                import: "EditarCte",
            },
            {
                enabled: true,
                menu: false,
                visible: false,
                id: "cte",
                route: "/substituicao",
                // permission:false,
                title: "CTe de substituição",
                import: "CteSubstituicao",
            },
            {
                enabled: true,
                menu: false,
                visible: false,
                id: "cte",
                route: "/subcontratacao",
                // permission:false,
                title: "CTe de Subcontratação",
                import: "Subcontratacao",
            },
            {
                enabled: true,
                menu: true,
                id: "cte",
                route: "/criar",
                icon: faFileCirclePlus,
                // permission:false,
                title: "Emitir",
                import: "Main",
            },
            {
                enabled: true,
                menu: true,
                id: "cte",
                route: "/emitir_multiplos",
                icon: faFileCirclePlus,
                // permission:false,
                title: "Emitir múltiplos",
                import: "EmitirMultiplos",
            },
            {
                enabled: true,
                menu: true,
                id: "cte",
                route: "/configuracoes",
                icon: faCog,
                // permission:false,
                title: "Configurações",
                import: "Configuracoes",
            },
        ]
    },
    {
        //HeaderBadge alterado estáticamente, mudar routes caso mude rota
        enabled: true,
        menu: true,
        id: "mdfe",
        section: "fiscal",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/mdfe",
        icon: faFileSignature,
        title: "MDFE",
        import: "Mdfe",
        children: [
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/listar",
                icon: faSearch,
                // permission:false,
                title: "Listar",
                import: "Listar",
            },
            {
                enabled: true,
                menu: false,
                visible: false,
                id: "mdfe",
                route: "/editar",
                // permission:false,
                title: "Editar",
                import: "Editar",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/criar",
                icon: faFileCirclePlus,
                // permission:false,
                title: "Emitir",
                import: "Main",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/configuracoes",
                icon: faCog,
                // permission:false,
                title: "Configurações",
                import: "Configuracoes",
            },
        ]
    },
    {
        //HeaderBadge alterado estáticamente, mudar routes caso mude rota
        enabled: true,
        menu: true,
        id: "mdfe",
        section: "fiscal",
        // Módulo MDFe v4 — gated por auth.v4_modules.ids contendo "mdfe".
        permission: true,
        route: "/mdfe-new",
        icon: faFileSignature,
        title: "MDFE Novo",
        import: "Mdfe",
        children: [
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/listar",
                icon: faSearch,
                permission: true,
                title: "Listar",
                import: "Listar",
            },
            {
                enabled: true,
                menu: false,
                visible: false,
                id: "mdfe",
                route: "/editar",
                permission: true,
                title: "Editar",
                import: "Editar",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/criar",
                icon: faFileCirclePlus,
                permission: true,
                title: "Emitir",
                import: "Main",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/configuracoes",
                icon: faCog,
                permission: true,
                title: "Configurações",
                import: "Configuracoes",
            },
        ]
    },
    {
        //HeaderBadge alterado estáticamente, mudar routes caso mude rota
        enabled: true,
        menu: true,
        id: "mdfe",
        section: "fiscal",
        // Módulo CIOT autônomo (v4) — compartilha a permissão do MDFe
        // (id "mdfe" no auth.v4_modules.ids). As páginas vivem em
        // front-dev4 (apps/web/src/app/app/ciot/*) e são roteadas pra cá
        // via verifyV4 em FrontV4/index.js.
        permission: true,
        route: "/ciot",
        icon: faFileContract,
        title: "CIOT",
        import: "Ciot",
        children: [
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/listar",
                icon: faSearch,
                permission: true,
                title: "Listar",
                import: "Listar",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/criar",
                icon: faFileCirclePlus,
                permission: true,
                title: "Emitir",
                import: "Main",
            },
            {
                enabled: true,
                menu: true,
                id: "mdfe",
                route: "/configuracoes",
                icon: faCog,
                permission: true,
                title: "Configurações",
                import: "Configuracoes",
            },
        ]
    },
    // {
    //     enabled: false,
    //     menu: true,
    //     id: "cte",
    //     route: "/cte",
    //     section:"fiscal",
    //     icon: faTimes,
    //     title: "Cte",
    //     import: "Cte",
    // },
]

const ATENDIMENTO_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "sac",
        //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "",
        section: "atendimento",
        icon: faHeadset,
        title: "SAC",
        import: "Sac",
        children: [
            {
                enabled: true,
                menu: true,
                id: "sac",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/sac/atendimento",
                section: "atendimento",
                icon: faHeadset,
                title: "Atendimento",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "sac",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/sac/incidentes",
                section: "atendimento",
                icon: faMessage,
                title: "Incidentes",
                import: "",
            },
            {
                enabled: true,
                menu: true,
                id: "sac",
                route: "/AberturaDeIncidentes",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                section: "atendimento",
                icon: faExclamationTriangle,
                title: "Abertura de incidentes",
                import: "Sac/AberturaDeIncidentes",
            },
            /* {
                enabled: true,
                menu: true,
                id: "incidentes_acompanhados",
                route: "/IncidentesAcompanhados",
                permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                section:"atendimento",
                icon: faClipboardList,
                title: "Incidentes Acompanhados",
                import: "IncidentesAcompanhados",
            }, */
            {
                enabled: true,
                menu: true,
                id: "sac",
                route: "/sac/indicadores",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                section: "atendimento",
                icon: faChartSimple,
                title: "Indicadores",
                import: "Tracking",
            },
            {
                enabled: true,
                menu: true,
                id: "sac",
                route: "/sac/configuracoes",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                section: "atendimento",
                icon: faCog,
                title: "Configurações",
                import: "Configuracao",
            },

        ],
    },
]

const GESTAO_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        // permission: false,
        // admin:true,
        section: "gestao",
        id: "certificados",
        route: "/certificados",
        icon: faFileInvoice,
        title: "Certificados",
        import: "Certificados",
    },

    {
        enabled: true,
        menu: true,
        // permission: false,
        admin: true,
        section: "gestao",
        id: "minha_empresa",
        route: "/minha-empresa",
        icon: faBuilding,
        title: "Minha empresa",
        import: "Cadastro/MinhaEmpresa",
    },
    {
        enabled: true,
        menu: true,
        // permission: false,
        section: "gestao",
        id: "cadastro_usuario",
        route: "/usuarios",
        icon: faUsers,
        title: "Usuários",
        import: "Cadastro/CadastroUsuario",
    },
    {
        enabled: true,
        menu: true,
        // permission: false,
        section: "gestao",
        id: "cadastro_relacao",
        route: "/empresas",
        icon: faHandshake,
        title: "Empresas",
        import: "Cadastro/Relacao",
    },
    {
        enabled: true,
        menu: true,
        super: true,
        // permission: false,
        section: "gestao",
        id: "criar_empresa",
        route: "/cadastro-empresa",
        icon: faUserNinja,
        title: "Criar empresa",
        import: "Cadastro/CriarEmpresa",
    },
]

const FERRAMENTAS_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "ferramentas",
        route: "/ferramentas",
        section: "ferramentas",
        icon: faToolbox,
        title: "Ferramentas",
        import: "Ferramentas",
        children: [
            {
                enabled: true,
                menu: true,
                id: "volumetria",
                route: "/volumetria",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                icon: faBoxesStacked,
                title: "Volumetria",
                import: "Volumetria",
            },
            {
                enabled: true,
                menu: true,
                id: "auditoria",
                route: "/auditoria",
                icon: faCamera,
                title: "Auditoria",
                import: "Auditoria",
            },
            {
                enabled: true,
                menu: true,
                id: "prazo_entrega",
                route: "/prazo-entrega",
                icon: faShippingFast,
                title: "Prazo de entrega",
                import: "PrazoEntrega",
            },
            {
                enabled: true,
                menu: true,
                id: "end_sem_rota",
                // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/EnderecoSemRota",
                icon: faMapMarkerAlt,
                title: "Endereco sem rota",
                import: "EnderecoSemRota",
            },
            {
                enabled: true,
                menu: true,
                id: "verificadas",
                //permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                route: "/verificadas",
                patch: "fileExclamation",
                title: "Verificadas",
                import: "Verificadas",
            },
            {
                enabled: true,
                menu: true,
                id: "operacoes",
                route: "/operacoes",
                icon: faClock,
                title: "Operações",
                import: "Operacoes",
            },
            {
                enabled: true,
                menu: true,
                permission: false,
                id: "feriados",
                route: "/feriados",
                icon: faCalendar,
                title: "Feriados",
                import: "V4",
            },
        ],
    },
    {
        enabled: true,
        menu: true,
        id: "pendencias",
        section: "ferramentas",
        // permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
        route: "/pendencias",
        icon: faFileAlt,
        title: "Pendências",
        import: "Pendencias",
    },
]

const INTEGRACOES_SECTION_MODULES = [
    {
        enabled: true,
        menu: true,
        id: "integracoes",
        section: "integracoes",
        route: "",
        icon: faBezierCurve,
        title: "Integrações",
        import: "Integracoes",
        children: [
            {
                enabled: true,
                menu: true,
                permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "sefaz",
                route: "/integracoes",
                icon: faUpload,
                title: "Inserir",
                import: "Sefaz",
            },
            {
                enabled: true,
                menu: true,
                permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "baixas",
                route: "/baixas",
                icon: faDownload,
                title: "Baixas",
                import: "Baixas",
            },
            {
                enabled: true,
                menu: true,
                permission: false, // TODO: esperar o módulo estar vindo na lista de módulos da empresa/base para ativar a permissão (true)
                id: "manifestar",
                route: "/manifestar",
                icon: faCheck,
                title: "Manifestar",
                import: "Manifestar",
            },
        ],
    },
]

export const MODULE_LIST = [
    DEFAULT_MODULE,
    {
        enabled: true,
        menu: true,
        id: "pesquisa",
        section: "search",
        route: "/pesquisa",
        icon: faSearch,
        title: "Pesquisa",
        import: "Pesquisar",
    },
    ...LOGISTICA_SECTION_MODULES,
    ...TRANSPORTE_SECTION_MODULES,
    ...FINANCEIRO_SECTION_MODULES,
    ...FISCAL_SECTION_MODULES,
    ...ATENDIMENTO_SECTION_MODULES,
    ...GESTAO_SECTION_MODULES,
    ...FERRAMENTAS_SECTION_MODULES,
    ...INTEGRACOES_SECTION_MODULES,
    IF_NEW_USER,
];
